import { Component } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { KPIService } from '../../modules/kpi/kpi.service';
import { AlkalmazasConfiguration, AlkalmazasokConfiguration, ConfigurationService, NyilvantartasiModulConfiguration } from '../../configuration/configuration.service';

import * as $ from 'jquery';
import { ActivatedRoute, NavigationStart, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { LocalStorageService } from '../../common';

const LAST_SELECTED_APPLICATION: string = "last-selected-app";

@Component({
  selector: 'app-menu',
  templateUrl: './app.menu.component.pug',
  styleUrls: ['./app.menu.component.sass']
})
export class AppMenuComponent {

  isExpanded = false;
  kpis: {};
  nyilvantartasiModulConfiguration: NyilvantartasiModulConfiguration;
  alkalmazasokConfiguration: AlkalmazasokConfiguration;
  alkalmazas: AlkalmazasConfiguration;
  menuterkep: any;

  constructor(
    public authService: AuthService,
    public configurationService: ConfigurationService,
    private kpiService: KPIService,
    private router: Router,
    private route: ActivatedRoute,
    private localStorage: LocalStorageService
  ) {
    this.alkalmazasokConfiguration = this.configurationService.alkalmazasokConfiguration;
    var appinls = localStorage.get(LAST_SELECTED_APPLICATION);
    if (appinls) {
      var app = this.alkalmazasokConfiguration.alkalmazasok.find(a => a.megnevezes == appinls);
      this.appactivate(app, false);
    }
    else
      this.menuterkepBeallitas();

    if (this.alkalmazasokConfiguration.engedelyezve) {
      this.router.events.pipe(filter(event => event instanceof NavigationStart)).subscribe(p => {
        var ps = p as NavigationStart;
        if (ps.url.startsWith('/apps/')) {
          var app = this.alkalmazasokConfiguration.alkalmazasok.find(a => '/' + a.route == ps.url);
          if (app && this.alkalmazas != app) {
            this.appactivate(app, false);
          }
        }
      });
    }

    this.authService.userRefreshed.subscribe(r => {
      this.alkalmazasokConfiguration.alkalmazasok.forEach(app => {
        app.felhasznaloLathatja = !app.szerepkor || this.authService.hasBusinessRule(app.szerepkor)
      });
    });

    this.configurationService.NyilvantartasiModulInicializalva.subscribe(r => {
      this.nyilvantartasiModulConfiguration = this.configurationService.nyilvantartasiModulConfiguration;
    });
    
    this.kpiService.updated.subscribe(r => {
      const pending = this.kpiService.getPendingKpis();

      const o: any = {};
      r.forEach(e => {
        o[e.indicatorType] = e;

        e.pending = Object.keys(pending).indexOf(e.indicatorType) !== -1 && pending[e.indicatorType];
        if (this.kpis && Object.keys(this.kpis).indexOf(e.indicatorType) >= 0) {
          e.pendingCount = this.kpis[e.indicatorType].pendingCount;
        }

        if (!e.pendingCount) { 
          e.pendingCount = e.count; 
        } else {
          if (e.pendingCount != e.count) {
            this.kpiService.clearPendingKpi(e.indicatorType);
            e.pending = false;
          }
        }

        e.pendingStyle = e.pending ? 'pendingkpi' : '';
      });
      this.kpis = o;
    });

    this.kpiService.updatedPending.subscribe(r => {
      const pending = this.kpiService.getPendingKpis();
      const o: any = this.kpis;

      Object.keys(o).forEach(e => {
        const oitem = o[e];

        oitem.pending = Object.keys(pending).indexOf(e) !== -1;
        oitem.pendingStyle = oitem.pending ? 'pendingkpi' : '';
        if (!oitem.pendingCount) { 
          oitem.pendingCount = oitem.count; 
        } else {
          if (oitem.pendingCount != oitem.count) {
            this.kpiService.clearPendingKpi(e);
          }
        }
      });
      this.kpis = o;
    });
  }

  public hasKPI(key: string): Boolean {
    if (this.kpis) {
      return Object.keys(this.kpis).indexOf(key) !== -1;
    } else {
      return false;
    }
  }

  public appactivate(app: AlkalmazasConfiguration, navigate = true) {
    this.alkalmazas = app.alapertelmezett ? undefined : app;
    this.localStorage.set(LAST_SELECTED_APPLICATION, app.megnevezes);
    this.menuterkepBeallitas();

    this.configurationService.riportModulConfiguration.engedelyezve = !this.alkalmazas || (this.alkalmazas.riportok.length > 0 && this.configurationService.riportModulConfiguration.riportmappak.length > 0); 

    if (app.route && navigate) this.router.navigate(app.route.split('/'));
  }

  public isNyilvantartasiElemCsoportVisible(nye: any): boolean {
    return !this.alkalmazas || this.alkalmazas.nyilvantartasok.includes(nye.csoportFelirat);
  }

  public isRiportVisible(r: any): boolean {
    return !this.alkalmazas || this.alkalmazas.riportok.includes(r.felirat);
  }

  public isFeladatkosarVisible(fs: any): boolean {
    return !this.alkalmazas || this.alkalmazas.feladatkosarak.includes(fs.felirat);
  }

  private menuterkepBeallitas() {
    this.menuterkep = {
      adatszolgaltatasok: !this.alkalmazas || this.alkalmazas.menuk.includes("adatszolgaltatasok"),
      ugyintezes: !this.alkalmazas || this.alkalmazas.menuk.includes("ugyintezes"),
      feladatkosar: !this.alkalmazas || this.alkalmazas.menuk.includes("feladatkosar"),
      ellenorzesek: !this.alkalmazas || this.alkalmazas.menuk.includes("ellenorzesek"),
      karbantartas_ui: !this.alkalmazas || this.alkalmazas.menuk.includes("karbantartas_ui"),
      karbantartas_admin: !this.alkalmazas || this.alkalmazas.menuk.includes("karbantartas_admin")
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/layout/menu/app.menu.component.ts